import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  noSetsTitleText: {
    fontSize: 22,
    fontWeight: '700',
    color: colors.darkGrey,
    marginBottom: 24,
  },
  noSetsView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
